var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0473EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.128 21.7559C14.3313 22.8392 15.278 23.6251 16.3805 23.6251H22.498C23.303 23.6251 23.9563 22.9717 23.9563 22.1667C23.9563 21.6892 23.9563 21.0726 23.9563 20.5001C23.9563 19.8926 23.7146 19.3092 23.2846 18.8792C22.8546 18.4501 22.2721 18.2084 21.6646 18.2084H18.193C18.0921 18.2084 18.0063 18.1367 17.988 18.0376L16.6946 10.9234C16.4963 9.83341 15.5471 9.04175 14.4396 9.04175C14.1255 9.04175 13.7971 9.04175 13.5013 9.04175C13.068 9.04175 12.6563 9.23508 12.3796 9.56841C12.1021 9.90258 11.988 10.3426 12.068 10.7692L14.128 21.7559Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3853 22.6693C17.3853 22.6693 16.6861 23.786 16.0986 24.7268C15.8178 25.1768 15.8028 25.7435 16.0594 26.2068C16.3169 26.671 16.8053 26.9585 17.3353 26.9585H22.9153C23.2594 26.9585 23.5403 26.6785 23.5403 26.3335C23.5403 25.9885 23.2594 25.7085 22.9153 25.7085H17.3353C17.2594 25.7085 17.1894 25.6677 17.1528 25.601C17.1161 25.5352 17.1186 25.4543 17.1586 25.3893L18.4453 23.331C18.6278 23.0385 18.5386 22.6527 18.2461 22.4702C17.9536 22.2877 17.5678 22.376 17.3853 22.6693Z",
    fill: "#0473EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.082 16.125H22.082C22.4262 16.125 22.707 15.845 22.707 15.5C22.707 15.155 22.4262 14.875 22.082 14.875H17.082C16.737 14.875 16.457 15.155 16.457 15.5C16.457 15.845 16.737 16.125 17.082 16.125Z",
    fill: "#0473EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/seat-icon.cff5cdbfc69b1ea9ec519c55f6607066.svg";
export { ForwardRef as ReactComponent };